/* 
 * Simple editor component that takes placeholder text as a prop 
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ReactQuill, { Quill } from 'react-quill'; // ES6
import classnames from 'classnames';

/*

 value={this.state.text}
                                    onChange={this.handleChange}
                                    formats={this.formats}
                                    style={{backgroundColor: '#FFFFFF', height: 100, fontColor: '#000000'}}
                                    />

*/


const styles = theme => ({
    root: {
      width: '100%',
      backgroundColor:'#FFFFFF'
    },
   
  });

class SonicEditor extends React.Component {
    constructor (props) {
      super(props)
      this.state = {theme: 'bubble' }

    }
    handleChange  = (html) => {
      const { update } = this.props
      console.log(html)
      update(html)
     // this.setState({ editorHtml: html });
    }
    handleThemeChange (newTheme) {
      if (newTheme === "core") newTheme = null;
      this.setState({ theme: newTheme })
    }
    
    render () {
      const { htmlContent, classes } = this.props
      return (
        <div className={classes.root}>
          <ReactQuill 
           // theme={this.state.theme}
            onChange={this.handleChange}
            value={htmlContent ?  htmlContent : ''}
            modules={SonicEditor.modules}
            formats={SonicEditor.formats}
            placeholder={this.props.placeholder}
           />
        

         </div>
       )
    }
  }
  
  /* 
   * Quill modules to attach to editor
   * See https://quilljs.com/docs/modules/ for complete options
   */
  SonicEditor.modules = {
    toolbar: [
      [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
      [{size: []}],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{'list': 'ordered'}, {'list': 'bullet'}, 
       {'indent': '-1'}, {'indent': '+1'}],
      ['link', 'image', 'video'],
      ['clean']
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    }
  }
  /* 
   * Quill editor formats
   * See https://quilljs.com/docs/formats/
   */
  SonicEditor.formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video'
  ]
  
  /* 
   * PropType validation
   */
  SonicEditor.propTypes = {
    placeholder: PropTypes.string,
  }
  

export default withStyles(styles)(SonicEditor);


// WEBPACK FOOTER //
// ./src/components/lib/SonicEditor.js